import createPage from "@src/components/page"
import React from "react"
import * as styles from "./pageCompare.module.scss"

import { secondsToHours } from "@src/utils/data-parser"
import { callYou, useEnteringTrail } from "@src/components/page/lib"
import { animated } from "react-spring"
import bgImg from "@images/2022/p5/21-100.jpg"
import iconBoomImg from "@images/2022/p5/22.png"
import iconFaceImg from "@images/2022/p5/23.png"
import iconCircleImg from "@images/2022/p5/24.png"
import iconPaperImg from "@images/2022/p5/25.png"

const parseData = ({ total: { compareToLastSpending } }) => {
  if (!compareToLastSpending) {
    return null
  }
  return {
    compareToLastSpending,
    hours: secondsToHours(Math.abs(compareToLastSpending) * 60),
  }
}

const PageCompare = createPage(
  ({ data, offset }) => {
    const parsed = parseData(data)
    const anime1Styles = useEnteringTrail(4, offset, { type: "mt" })
    const anime2Styles = useEnteringTrail(1, offset, { step: 0.4, type: "mb" })

    if (!parsed) {
      return null
    }

    const {
      compareToLastSpending,
      hours: { hours, minutes, seconds },
    } = parsed
    const target = callYou(data)

    return (
      <>
        <div>
          <div className="iconsGroup">
            <div>
              <animated.img
                src={iconPaperImg}
                className={styles.iconPaper}
                style={anime1Styles[0]}
              />
              <animated.img
                src={iconCircleImg}
                className={styles.iconCircle}
                style={anime1Styles[1]}
              />
              <animated.img
                src={iconFaceImg}
                className={styles.iconFace}
                style={anime1Styles[2]}
              />
              <animated.img
                src={iconBoomImg}
                className={styles.iconBoom}
                style={anime1Styles[3]}
              />
            </div>
          </div>
        </div>

        <animated.div style={anime2Styles[0]}>
          相较于2021年
          <br />
          今年{target}收听节目总时长
          <br />
          <span className="gColor">
            {compareToLastSpending > 0 ? "多" : "少"}了
          </span>
          {hours && (
            <span>
              <span className="gColor">{hours}</span>
              小时
            </span>
          )}
          <span>
            <span className="gColor">{minutes || seconds}</span>
            {minutes ? "分钟" : "秒"}
          </span>
        </animated.div>
      </>
    )
  },
  {
    className: "pageLayout2",
  }
)

export const pageCompareData = {
  key: "compare",
  bgImg,
  Page: PageCompare,
  shouldHide: ({ total: { compareToLastSpending } }) =>
    !(compareToLastSpending > 0),
}

export default PageCompare
